import { Div } from '../../../base/components/native/div'
import { Img } from '../../../base/components/native/img'
import images from '../../../configs/images'

export const StarIcon = (status = 0) => {

    const base = Div()
    const pos = Img(images.ICONS.START_POS, {width: 28})
    const neg = Img(images.ICONS.STAR_NEG, {width: 28})

    base.append(pos, neg)
    if (status === 0) {
        neg.style({display: 'none'});
    } else {
        pos.style({display: 'none'});
    }
    base.el.onclick = () => {
        status = 1 - status;
        neg.style({display: (status === 1) ? 'block' : 'none'});
        pos.style({display: (status === 0) ? 'block' : 'none'});
        base.emit('change', status)
    };
    base.cssClass({
        cursor: 'pointer',
        margin: '10px'
    })

    return base
}